import StoreDemoControlUnitCardGrid from '../../../../customized/store-demo/components/DeviceManager/ControlUnit/ControlUnitCardGrid/StoreDemoControlUnitCardGrid';
import { ToggleComponent } from '../../../../featureToggle';
import ControlUnitCardGridSimple from './ControlUnitCardGrid';

export default ToggleComponent(ControlUnitCardGridSimple, {
  styledComponentsVariants: {
    techdays: StoreDemoControlUnitCardGrid,
  },
});
